<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid fill-height>
    <v-flex xs12 sm10 offset-sm1 md6 offset-md3 lg6 offset-lg3>

      <v-layout row wrap>
        <v-flex xs12>
          <div>
            <p :class="config.campagnaWeb=='S' ? 'primary--text display-2 font-weight-bold text-md-center sellaBold' : 'primary--text display-2 font-weight-bold text-md-center sellaBold'">
              Informativa in materia di trattamento dei dati personali
            </p>
          </div>
          <p flat style="font-size: 10px" :class="config.campagnaWeb=='S' ? 'bFTextColor--text ' : 'theme--light'">
            Clicca qui per scaricare l'<a href="https://www.sellapersonalcredit.it/Resources/files/pdf_sito/privacy_site.pdf" title="Informativa in materia di trattamento dei dati personali" target="_blank">Informativa generale</a>
          </p>

          <p :class="config.campagnaWeb=='S' ? 'bFTextColor--text sellaRegular' : 'sellaRegular'">
            Il Regolamento generale UE sulla protezione dei dati personali n. 2016/679 tutela il trattamento dei dati personali delle persone fisiche. Per “trattamento” si intende qualunque operazione o complesso di operazioni, con o senza l’ausilio di mezzi elettronici o comunque automatizzati, riguardanti la raccolta, la registrazione, l’organizzazione, la conservazione, l’elaborazione, la modificazione, la selezione, l’estrazione, il raffronto, l’utilizzo, l’interconnessione, il blocco, la comunicazione, la diffusione, la cancellazione e la distruzione dei dati medesimi. Sono “dati personali” le informazioni relative a persone fisiche, identificate o identificabili, anche indirettamente, mediante riferimento a qualsiasi altra informazione, ivi compreso un numero di identificazione personale.
          </p>

          <p class="primary--text headline text-xs-center"
             :class="config.campagnaWeb=='S' ? 'bFTextColor--text headline text-xs-center' : 'primary--text headline text-xs-center'">
            I dati personali devono essere:
          </p>
          <p :class="config.campagnaWeb=='S' ? 'bFTextColor--text sellaRegular' : 'sellaRegular'">
            a) trattati in modo lecito, trasparente e secondo correttezza;<br>
            b) raccolti e registrati per scopi determinati, espliciti e legittimi, ed utilizzati in altre operazioni del trattamento in termini compatibili con tali scopi;<br>
            c) esatti e, se necessario, aggiornati;<br>
            d) pertinenti, completi e non eccedenti rispetto alle finalità per le quali sono raccolti o successivamente trattati;<br>
            e) conservati in una forma che consenta l'identificazione dell'interessato per un periodo di tempo non superiore a quello necessario agli scopi per i quali essi sono stati raccolti o successivamente trattati.<br>
            f) trattati in maniera da garantire un'adeguata sicurezza dei dati personali
          </p>

          <p class="primary--text headline text-xs-center"
             :class="config.campagnaWeb=='S' ? 'bFTextColor--text headline text-xs-center' : 'primary--text headline text-xs-center'">
            Il Titolare del trattamento:
          </p>
          <p :class="config.campagnaWeb=='S' ? 'bFTextColor--text sellaRegular' : 'sellaRegular'">
            La persona fisica, la persona giuridica, la pubblica amministrazione e qualsiasi altro ente, associazione od organismo cui competono, anche unitamente ad altro titolare, le decisioni in ordine alle finalità, alle modalità del trattamento di dati personali e agli strumenti utilizzati, ivi compreso il profilo della sicurezza.
            <br>
            Il titolare del trattamento è Sella Personal Credit S.P.A., con sede in Torino (TO) - 10121, Via Bellini n. 2 – Tel. 011/5061111
          </p>

          <p class="primary--text headline text-xs-center"
             :class="config.campagnaWeb=='S' ? 'bFTextColor--text headline text-xs-center' : 'primary--text headline text-xs-center'">
            Il Responsabile del trattamento:
          </p>
          <p :class="config.campagnaWeb=='S' ? 'bFTextColor--text sellaRegular' : 'sellaRegular'">
            La persona fisica, la persona giuridica, la pubblica amministrazione e qualsiasi altro ente, associazione od organismo preposti dal titolare al trattamento di dati personali.
          </p>

          <p class="primary--text headline text-xs-center"
             :class="config.campagnaWeb=='S' ? 'bFTextColor--text headline text-xs-center' : 'primary--text headline text-xs-center'">
            Responsabile della protezione dei dati (RPD) o Data Protection Officer (DPO)
          </p>
          <p :class="config.campagnaWeb=='S' ? 'bFTextColor--text sellaRegular' : 'sellaRegular'">
            Figura introdotta dal Regolamento, avente tra i principali compiti quello di informare e fornire consulenza al Titolare, Responsabili e Incaricati in merito alla protezione dei dati; sorvegliare l'osservanza del Regolamento; fornire pareri in merito alla valutazione d'impatto sulla protezione dei dati; cooperare con l'autorità di controllo.
            Il Responsabile della Protezione dei Dati (di seguito anche “RPD” o “DPO – Data Protection Officer”) può essere contattato ai seguenti recapiti:<br>
            - indirizzo postale di Sella Personal Credit S.p.A., Via Bellini, 2, 10121 Torino;
            - indirizzo e-mail: <a href="dpo@sella.it">dpo@sella.it</a>
          </p>

          <p class="primary--text headline text-xs-center"
             :class="config.campagnaWeb=='S' ? 'bFTextColor--text headline text-xs-center' : 'primary--text headline text-xs-center'">
            Il Garante:
          </p>
          <p :class="config.campagnaWeb=='S' ? 'bFTextColor--text sellaRegular' : 'sellaRegular'">
            L’organo collegiale preposto al controllo della corretta applicazione della normativa, dinanzi al quale è possibile far valere i propri diritti in via alternativa all’autorità giudiziaria.
          </p>

          <p class="primary--text headline text-xs-center"
             :class="config.campagnaWeb=='S' ? 'bFTextColor--text headline text-xs-center' : 'primary--text headline text-xs-center'">
            I principali soggetti individuati dal Regolamento sono:
          </p>
          <p :class="config.campagnaWeb=='S' ? 'bFTextColor--text sellaRegular' : 'sellaRegular'">
            L’Interessato, ossia la persona fisica cui si riferiscono i dati personali ha diritto di ottenere l'indicazione:<br>
            a) dell'origine dei dati personali;<br>
            b) delle finalità e modalità del trattamento;<br>
            c) della logica applicata in caso di trattamento effettuato con l'ausilio di strumenti elettronici;<br>
            d) degli estremi identificativi del titolare;<br>
            e) dei soggetti o delle categorie di soggetti ai quali i dati personali possono essere comunicati o che possono venirne a conoscenza in qualità di rappresentante designato nel territorio dello Stato, di responsabili o incaricati.
          </p>

          <p class="primary--text headline text-xs-center"
             :class="config.campagnaWeb=='S' ? 'bFTextColor--text headline text-xs-center' : 'primary--text headline text-xs-center'">
            Diritti dell'interessato:
          </p>
          <p :class="config.campagnaWeb=='S' ? 'bFTextColor--text sellaRegular' : 'sellaRegular'">
            a) diritto di accesso: diritto di ottenere dal Titolare la conferma che sia o meno in corso un trattamento di dati personali e in tal caso, di ottenere l’accesso ai dati personali ed informazioni di dettaglio riguardo l’origine, le finalità, le categorie di dati trattati, destinatari di comunicazione e/o trasferimento dei dati ed altro ancora;<br>
            b) diritto di rettifica: diritto di ottenere dal Titolare la tempestiva modifica dei dati personali inesatti, nonché l’integrazione dei dati personali incompleti.<br>
            c) diritto alla cancellazione (“oblio”): diritto di ottenere dal Titolare la tempestiva trasformazione in forma anonima dei dati nei casi in cui:<br>

            • i dati personali non sono più necessari rispetto alle finalità del trattamento;<br>
            • il consenso su cui si basa il trattamento è revocato e non sussiste altro fondamento giuridico per il trattamento;<br>
            • i dati personali sono stati trattati illecitamente;<br>
            • i dati personali devono essere cancellati per adempiere ad un obbligo legale;<br>

            d) diritto alla limitazione del trattamento: diritto di ottenere dal Titolare la limitazione del trattamento, nei casi in cui sia contestata l’esattezza dei dati personali (per il periodo necessario al Titolare alla verificare dell’esattezza di tali dati personali), se il trattamento è illecito e/o l’interessato si è opposto al trattamento;<br>
            e) diritto alla portabilità dei dati: diritto di ricevere in un formato strutturato, di uso comune e leggibile da dispositivo automatico i dati personali e di trasmettere tali dati ad altro Titolare del trattamento, solo per i casi in cui il trattamento sia basato sul consenso o sul contratto e per i soli dati trattati tramite strumenti elettronici;<br>
            f) diritto di proporre un reclamo a un’autorità di controllo: fatto salvo ogni altro ricorso amministrativo o giurisdizionale, l'interessato che ritenga che il trattamento che lo riguardi violi il Regolamento ha il diritto di proporre reclamo all'autorità di controllo dello Stato membro in cui risiede o lavora abitualmente, ovvero dello Stato in cui si è verificata la presunta violazione. Inoltre, l’interessato, ha il diritto di revocare in qualsiasi momento il consenso eventualmente prestato a specifiche attività facoltative, fermo restando la liceità del trattamento eseguito antecedentemente alla revoca.<br>
          </p>

          <br>

          <p class="primary--text headline text-xs-center"
             :class="config.campagnaWeb=='S' ? 'bFTextColor--text headline text-xs-center' : 'primary--text headline text-xs-center'">
            Dati forniti volontariamente dall'utente
          </p>
          <p :class="config.campagnaWeb=='S' ? 'bFTextColor--text sellaRegular' : 'sellaRegular'">
            La navigazione nel sito è anonima. I dati personali sono raccolti al momento della compilazione on-line della richiesta di un prodotto finanziario; La raccolta e il trattamento dei dati personali conferiti è diretta a finalità connesse e strumentali alla gestione del rapporto di finanziamento, di marketing e promozione commerciale effettuate da Sella Personal Credit o da società terze. La raccolta e il trattamento dei dati personali conferiti è diretta altresì allo svolgimento delle operazioni di istruzione e valutazione di informazioni pre-contrattuali, nonché a finalità di gestione della clientela, tutela del credito e prevenzione del sovraindebitamento commerciale.
            <br>
            Il trattamento dei Suoi dati personali è effettuato dal titolare nel rispetto delle condizioni di liceità previste dal Regolamento ed è limitato a quanto necessario allo svolgimento, da parte del Titolare e/o di terzi per conto della medesima, di attività connesse e strumentali, ed è svolto esclusivamente in presenza di almeno una delle seguenti condizioni:<br>
            <br>
            • adempimento di obblighi di legge;<br>
            • esecuzione del contratto da Lei stipulato con il titolare e attività precontrattuali;<br>
            • consenso per specifiche finalità;<br>
            • legittimo interesse del Titolare<br>
            <br>
            Il consenso dell’interessato ai trattamenti per specifiche finalità (marketing e promozione commerciale o profilazione) è richiesto separatamente ed espressamente indicato come facoltativo. In ogni caso, è sempre possibile opporsi a tali forme di trattamento inviando richiesta a Sella Personal Credit . L'invio facoltativo, esplicito e volontario di posta elettronica agli indirizzi indicati su questo sito comporta la successiva acquisizione dell'indirizzo del mittente, necessario per rispondere alle richieste e degli eventuali altri dati personali inseriti nella missiva.
            <br><br>
            Qualora l’interessato abbia manifestato il consenso il titolare è autorizzato a:<br>

            • conservare la documentazione delle attività precontrattuali (es. preventivi, richiesta di prodotti e servizi che non si è conclusa con la sottoscrizione del contratto);<br>
            • svolgere attività finalizzate al miglioramento continuo del servizio offerto, quali:<br>

            • rilevazione del grado di soddisfazione sulla qualità dei servizi resi;<br>
            • l’elaborazione di studi e ricerche di mercato;<br>
            • l’attività di marketing di prodotti e servizi<br>
            • l’attività di profilazione per proporre prodotti e servizi personalizzati che rispondono alle Sue esigenze.<br>
            <br>
            Il legittimo interesse del Titolare è orientato ad offrire prodotti e servizi che soddisfano al meglio le esigenze dei Clienti. Per questa attività Sella Personal Credit individua i destinatari dell’offerta commerciale attraverso criteri non invasivi (es. età, residenza, peggioramento del “merito creditizio, utilizzo del servizio di internet banking, ecc.). Sella Personal Credit effettua preventivamente una valutazione dell’impatto di questa attività sui diritti, gli interessi e le libertà dei destinatari. Inoltre, Sella Personal Credit permette agli stessi di non beneficiare ulteriormente di questo servizio attraverso l’opzione di cancellazione dalla lista ad ogni occasione di contatto.
          </p>

          <p class="primary--text headline text-xs-center"
             :class="config.campagnaWeb=='S' ? 'bFTextColor--text headline text-xs-center' : 'primary--text headline text-xs-center'">
            Comunicazione dati trattati
          </p>
          <p :class="config.campagnaWeb=='S' ? 'bFTextColor--text sellaRegular' : 'sellaRegular'">
            Sella Personal Credit può comunicare i dati dell’interessato a soggetti terzi appartenenti alle categorie di seguito riportate:<br>
            <br>
            a) per adempimento di obblighi di legge:<br>

            • soggetti che curano la revisione contabile e la certificazione del bilancio;<br>
            • autorità e organi di vigilanza e controllo e in generale soggetti, pubblici o privati, con funzioni di tipo pubblicistico;<br>
            • autorità e organi di vigilanza (Banca d'Italia, MEF, CONSOB, EBA, ecc.);<br>
            • società di supporto alla prevenzione di frodi;<br>
            • altri intermediari finanziari appartenenti al Gruppo Banca Sella nel caso in cui le Sue operazioni siano ritenute “sospette” ai sensi della normativa Antiriciclaggio (articoli 35 e 39 del d. lgs. 90 del 25 maggio 2017), in conformità alle prescrizioni di cui al Provvedimento Generale dell'Autorità Garante per la protezione dei dati personali del 10 settembre 2009 denominato "Misure relative alle comunicazioni fra intermediari finanziari appartenenti al medesimo gruppo in materia di antiriciclaggio";<br>
            • archivio istituito presso il Ministero dell'Economia e delle Finanze (di seguito “MEF”), ai sensi degli artt. 30-ter, commi 7 e 7-bis, e 30-quinquies, del D.lgs. 13 agosto 2010 n. 141, esclusivamente per le finalità di prevenzione del furto di identità. Gli esiti della procedura di riscontro sull'autenticità dei dati non saranno diffusi, ma potranno essere comunicati alleautorità e agli organi di vigilanza e di controllo;<br>
            <br>
            b) per esecuzione del contratto di cui l’interessato è parte:<br>

            • soggetti che gestiscono il recupero crediti o forniscono prestazioni professionali di consulenza e assistenza fiscale, legale e giudiziale;<br>
            • soggetti che supportano le attività di istruttoria, valutazione, erogazione, incasso ed assicurazione del credito;<br>
            • Sistemi di Informazioni Creditizie (S.I.C.).<br>
            <br>
            c) per svolgere attività facoltative autorizzate da apposito consenso.<br>

            Sella Personal Credit SpA, in base alla attività che deve svolgere, potrà usare i Suoi Dati personali in Italia e all’estero e comunicarli anche a soggetti con sede in Stati che si trovano al di fuori dell’Unione Europea e che potrebbero non garantire un livello di protezione adeguato secondo la Commissione Europea. In questi casi, il trasferimento dei Suoi Dati personali verso soggetti al di fuori dell’Unione Europea avverrà con le opportune ed adeguate garanzie in base alla legge applicabile.
          </p>

          <p class="primary--text headline text-xs-center"
             :class="config.campagnaWeb=='S' ? 'bFTextColor--text headline text-xs-center' : 'primary--text headline text-xs-center'">
            Tempi di conservazione dei dati
          </p>
          <p :class="config.campagnaWeb=='S' ? 'bFTextColor--text sellaRegular' : 'sellaRegular'">
            Sella Personal Credit conserva i dati in una forma che consente l’identificazione dei soggetti interessati per un arco di tempo necessario al conseguimento delle specifiche finalità del trattamento, nel rispetto degli obblighi contrattuali e/o normativi.
          </p>

          <p class="primary--text headline text-xs-center"
             :class="config.campagnaWeb=='S' ? 'bFTextColor--text headline text-xs-center' : 'primary--text headline text-xs-center'">
            Dati biometrici
          </p>
          <p :class="config.campagnaWeb=='S' ? 'bFTextColor--text sellaRegular' : 'sellaRegular'">
            Sella Personal Credit S.p.A. ha implementato una soluzione informatica che consente alla clientela di sottoscrivere elettronicamente documentazione contrattuale al fine di eliminare le stampe cartacee. Tale soluzione, denominata “Firma Elettronica Avanzata grafometrica” (di seguito “FEA”), è determinata a dematerializzare i processi gestionali con la progressiva sostituzione della documentazione cartacea con documentazione digitale. In sintesi, il servizio di FEA consiste nella firma apposta dal Titolare con uno stilo elettronico su una tavoletta grafica ad alta sensibilità in grado di rilevare i dati relativi alle caratteristiche della firma del cliente, quali posizione - tempo - pressione - velocità - accelerazione, ed associarli al documento informatico riprodotto sullo schermo della tavoletta unitamente all’immagine della firma stessa, eliminando la necessità di stampare contratti da archiviare e/o consegnare ai clienti. La FEA resta valida e rilevante ad ogni effetto di legge, al pari di quella apposta su supporto cartaceo. I documenti informatici così prodotti e firmati sono trasmessi al cliente a mezzo e-mail, nonché conservati da Sella Personal Credit S.p.A. per il tempo stabilito dalla legge.
            <br><br>
            <a href="https://www.sellapersonalcredit.it/Resources/files/pdf_sito/informativa_FEA.pdf" title="Informativa FEA" target="_blank"> Clicca qui </a> per scaricare l'Informativa Firma Elettronica Avanzata grafometrica.
            <br>
            <a @click="showModalViewSocTerze"> Clicca qui </a> se vuoi conoscere le Società terze che hanno conferito l'apposito incarico a Sella Personal Credit spa per l'utilizzo della Firma Elettronica Avanzata grafometrica.
            <br>
            <a @click="showRespEsterni"> Clicca qui </a> per conoscere l'elenco dei  Responsabili  esterni di Sella Personal Credit S.p.A. nell'ambito della conservazione dei dati biometrici.
          </p>

          <p class="primary--text headline text-xs-center"
             :class="config.campagnaWeb=='S' ? 'bFTextColor--text headline text-xs-center' : 'primary--text headline text-xs-center'">
            SIC
          </p>
          <p :class="config.campagnaWeb=='S' ? 'bFTextColor--text sellaRegular' : 'sellaRegular'">
            Informazioni sui finanziamenti erogati dalle banche e dagli altri intermediari finanziari sono presenti nei Sistemi di Informazioni Creditizie (S.I.C.). Sella Personal Credit , ai fini della valutazione della richiesta di finanziamento, consulta le informazioni presenti presso i S.I.C. per la valutazione del merito creditizio e del rischio di sovraindebitamento del consumatore. Per il trattamento dei dati effettuato da tali enti, si veda la specifica Informativa. Clicca qui per scaricare l'
            <a href="https://www.sellapersonalcredit.it/Resources/files/pdf_sito/Cod_deontologico.pdf" title="Informativa SIC Codice deontologico" target="_blank">Informativa SIC</a>
          </p>

          <p class="primary--text headline text-xs-center"
             :class="config.campagnaWeb=='S' ? 'bFTextColor--text headline text-xs-center' : 'primary--text headline text-xs-center'">
            MODALITA' DEL TRATTAMENTO
          </p>
          <p :class="config.campagnaWeb=='S' ? 'bFTextColor--text sellaRegular' : 'sellaRegular'">
            Il trattamento dei dati avviene mediante strumenti manuali, informatici e telematici con logiche strettamente correlate alle finalità per cui sono stati raccolti. Specifiche misure di sicurezza sono osservate per prevenire la perdita dei dati, usi illeciti e non corretti ed accessi non autorizzati.<br><br>

            MODALITA' DI ESERCIZIO DEI DIRITTI Inviare richiesta scritta a Sella Personal Credit S.p.A., Ufficio clienti, Via Bellini, 2 10121 Torino o tramite Tel. 0115061111, Fax 0115732578, e-mail alla casella
            <a href="mailto:clienti@sellapersonalcredit.it">clienti@sellapersonalcredit.it</a>
            PEC: <a href="mailto:sellapersonalcredit@actaliscertymail.it">sellapersonalcredit@actaliscertymail.it</a><br><br>

            Nel caso in cui non dovesse ritenersi soddisfatto della nostra risposta, ha il diritto di presentare un reclamo all’Autorità Garante per la Protezione dei dati personali, Piazza Monte Citorio, 121 - 00186, Roma, Tel: (+39) 06.696771 o visitando il
            <a href="https://www.garanteprivacy.it">www.garanteprivacy.it</a><br>
          </p>

          <v-dialog v-model="modalViewSocTerze" max-width="900px">
            <v-card>
              <v-card-text>
                <p class="primary--text headline text-xs-center"
                   :class="config.campagnaWeb=='S' ? 'bFTextColor--text headline text-xs-center' : 'primary--text headline text-xs-center'">
                  Società terze che hanno conferito l’apposito incarico a Sella Personal Credit SpA per l’utilizzo della Firma Elettronica Avanzata grafometrica:
                </p>
                <p :class="config.campagnaWeb=='S' ? 'bFTextColor--text sellaRegular' : 'sellaRegular'">
                  • MetLife Europe D.A.C. Rappresentanza Generale per l’Italia<br>
                  • Europ Assistance Italia SpA<br>
                  • Crif SpA<br>
                  <br>
                  Sella Personal Credit S.p.A.<br>
                  <a href="https://www.sellapersonalcredit.it">Sito</a>
                </p>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="modalViewRespEsterni" max-width="900px">
            <v-card>
              <v-card-text>
                <p class="primary--text headline text-xs-center"
                   :class="config.campagnaWeb=='S' ? 'bFTextColor--text headline text-xs-center' : 'primary--text headline text-xs-center'">
                  Responsabili esterni del trattamento di Sella Personal Credit S.p.A. nell’ambito della conservazione dei dati biometrici:
                </p>
                <p :class="config.campagnaWeb=='S' ? 'bFTextColor--text sellaRegular' : 'sellaRegular'">
                  • Namirial SpA<br>
                  <br>
                  Sella Personal Credit S.p.A.<br>
                  <a href="https://www.sellapersonalcredit.it">Sito</a>
                </p>
              </v-card-text>
            </v-card>
          </v-dialog>

        </v-flex>
      </v-layout>

    </v-flex>
  </v-container>
</template>

<script>
export default {
  data (){
    return {
      modalViewSocTerze: false,
      modalViewRespEsterni: false
    }
  },
  props:{
    config: {}
  },
  methods: {
    showModalViewSocTerze(){
      this.modalViewSocTerze = true;
    },
    showRespEsterni(){
      this.modalViewRespEsterni = true;
    }
  }
}
</script>


<style scoped>

@font-face {
  font-family: 'Sella';
  src: url('../assets/fonts/Sella-Regular.woff2') format('woff2'),
  url('../assets/fonts/Sella-Regular.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Sella Stencil';
  src: url('../assets/fonts/SellaStencil-Regular.woff2') format('woff2'),
  url('../assets/fonts/SellaStencil-Regular.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Sella';
  src: url('../assets/fonts/Sella-Bold.woff2') format('woff2'),
  url('../assets/fonts/Sella-Bold.woff') format('woff');
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: 'Sella Stencil';
  src: url('../assets/fonts/SellaStencil-Bold.woff2') format('woff2'),
  url('../assets/fonts/SellaStencil-Bold.woff') format('woff');
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: 'Sella Stencil';
  src: url('../assets/fonts/SellaStencil-Medium.woff2') format('woff2'),
  url('../assets/fonts/SellaStencil-Medium.woff') format('woff');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Sella';
  src: url('../assets/fonts/Sella-Medium.woff2') format('woff2'),
  url('../assets/fonts/Sella-Medium.woff') format('woff');
  font-weight: 500;
  font-style: normal;
}

.sellaRegular {
  font-family: 'Sella' !important;
}

.sellaStencil {
  font-family: 'Sella Stencil' !important;
}
</style>
